export enum IRoleType {
  DOCTOR = "DOCTOR",
  PATIENT = "PATIENT",
  JR_DOCTOR = "JR_DOCTOR",
  PHARMACY = "PHARMACY",
  DIAGNOSTIC_CENTER = "DIAGNOSTIC_CENTER",
  GUEST = "GUEST",
  ADMIN = "ADMIN",
}
